import React from 'react'
import { Route, Routes } from 'react-router-dom';
import SiteSetting from '../site-setting/SiteSetting';

const SiteSettingRoutes = () => {
    return (
        <>
            <Routes>
                <Route path='/setting' element={<SiteSetting />} />
            </Routes>
        </>
    )
}

export default SiteSettingRoutes;